export default __webpack_public_path__ + "static/media/metal.25f4ebb1.png";